(function () {
  if (window.LuminateCartRecommendations) return;
  var states = new WeakMap();
  function syncSection(box, items) {
    // Never relabel a substitute as an upsell, including stale response markup.
    items.querySelectorAll('[data-cart-recommendation]').forEach(function (card) {
      if (card.dataset.cartRecommendationKind !== 'complementary') card.remove();
    });
    var heading = box.querySelector('.lum-cart-complements__heading');
    if (heading) heading.textContent = 'You may also like';
    box.hidden = items.children.length === 0;
  }
  function appendComplement(items, candidate) {
    var id = candidate.dataset.cartRecommendation;
    if (candidate.dataset.cartRecommendationKind !== 'complementary') return;
    if (!/^\d+$/.test(id || '') || items.children.length >= 3 || items.querySelector('[data-cart-recommendation="' + id + '"]')) return;
    items.appendChild(candidate);
  }
  async function refresh() {
    var box = document.querySelector('[data-cart-recommendations]');
    if (!box) return;
    var items = box.querySelector('[data-cart-recommendation-items]');
    if (!items) return;
    syncSection(box, items);
    var state = states.get(box);
    if (state && (state.running || state.done || Date.now() < state.retryAt)) return;
    if (items.children.length >= 3) return;
    state = { running: true, done: false, retryAt: 0 };
    states.set(box, state);
    var sources = (box.dataset.sourceIds || '').split(',').filter(function (id) { return /^\d+$/.test(id); }).slice(0, 6);
    var failed = false;
    box.setAttribute('aria-busy', 'true');
    try {
      for (var i = 0; i < sources.length; i++) {
        if (!box.isConnected) return;
        if (items.children.length >= 3) break;
        try {
          var url = new URL(box.dataset.recommendationsUrl, window.location.origin);
          if (url.origin !== window.location.origin) break;
          var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          url.searchParams.set('section_id', 'cart-recommendations');
          url.searchParams.set('product_id', sources[i]);
          url.searchParams.set('intent', 'complementary');
          url.searchParams.set('limit', '10');
          var response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) { failed = true; continue; }
          var html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!box.isConnected) return;
          var candidates = html.querySelectorAll('[data-cart-recommendation-results] [data-cart-recommendation]');
          for (var j = 0; j < candidates.length; j++) appendComplement(items, candidates[j]);
          syncSection(box, items);
        } catch (error) { failed = true; }
      }
    } finally {
      state.running = false;
      state.done = !failed;
      state.retryAt = failed ? Date.now() + 5000 : 0;
      box.setAttribute('aria-busy', 'false');
    }
  }
  window.LuminateCartRecommendations = { refresh: refresh };
  document.addEventListener('luminate:cart-rendered', refresh);
  document.addEventListener('luminate:cart-open', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
